import React, { createContext, useContext, useMemo, useState } from 'react';
import proptypes from 'prop-types';
import { track } from '../utils';
import { ENTRY_TYPES } from '../constants';

const { node, string, bool, shape, arrayOf, oneOf } = proptypes;

const FuelTypeContext = createContext({
  children: null,
  itemId: '',
  isCaching: false
});
export const useFuelType = () => useContext(FuelTypeContext);

export const FuelTypeProvider = ({
  children,
  entryType,
  position,
  types,
  categories,
  drawerStatus
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onAlertClick = () => {
    setDrawerOpen(true);
    track({ eventType: 'click' });
  };

  const {
    isDryer,
    isRange,
    isEither,
    hasDualFuel
  } = drawerStatus;

  const value = useMemo(() => ({
    entryType,
    position,
    onAlertClick,
    drawerOpen,
    setDrawerOpen,
    types,
    categories,
    isDryer,
    isRange,
    isEither,
    hasDualFuel
  }), [
    entryType,
    position,
    onAlertClick,
    drawerOpen,
    setDrawerOpen,
    types,
    categories,
    isDryer,
    isRange,
    isEither,
    hasDualFuel
  ]);

  return (
    <FuelTypeContext.Provider value={value}>
      {children}
    </FuelTypeContext.Provider>
  );
};

FuelTypeProvider.propTypes = {
  children: node.isRequired,
  entryType: oneOf(ENTRY_TYPES).isRequired,
  position: oneOf(['left', 'right']).isRequired,
  types: arrayOf(string).isRequired,
  categories: arrayOf(string).isRequired,
  drawerStatus: shape({
    isDryer: bool,
    isRange: bool,
    isEither: bool,
    hasDualFuel: bool
  }).isRequired
};
